import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import MailOutlinedIcon from '@material-ui/icons/MailOutlined';
import DraftsOutlinedIcon from '@material-ui/icons/DraftsOutlined';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class LettersTable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, data } = this.props;

    return (
      <div className={classes.root}>
        {data.map((letter, index) => (
          <React.Fragment key={index}>
            <Hidden xsDown>
              <Grid container spacing={24} className={classes.row}>
                <Grid item xs={3}>
                  <Typography className={!letter.viewed ? classes.bold : ''}>
                    {letter.date}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    className={
                      !letter.viewed
                        ? `${classes.bold} ${classes.center}`
                        : classes.center
                    }
                  >
                    {letter.viewed ? (
                      <DraftsOutlinedIcon className={classes.readIcon} />
                    ) : (
                      <MailOutlinedIcon className={classes.unreadIcon} />
                    )}
                    <div className={classes.letterTitle}>{letter.title}</div>
                  </Typography>
                </Grid>
                <Grid item xs={3} className={classes.right}>
                  <Typography className={!letter.viewed ? classes.bold : ''}>
                    {letter.viewLink}
                  </Typography>
                </Grid>
              </Grid>
            </Hidden>
            <Hidden smUp>
              <Grid container spacing={24} className={classes.row}>
                <Grid item xs={1}>
                  {letter.viewed ? (
                    <DraftsOutlinedIcon className={classes.readIcon} />
                  ) : (
                    <MailOutlinedIcon className={classes.unreadIcon} />
                  )}
                </Grid>
                <Grid item xs={11}>
                  <Grid container spacing={24}>
                    <Grid item xs={12}>
                      <Typography
                        className={
                          !letter.viewed
                            ? `${classes.bold} ${classes.center}`
                            : classes.center
                        }
                      >
                        {letter.date}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        className={!letter.viewed ? classes.bold : ''}
                      >
                        {letter.title}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        className={!letter.viewed ? classes.bold : ''}
                      >
                        {letter.viewLink}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Hidden>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

LettersTable.propTypes = {};

LettersTable.defaultProps = {};

export default withStyles(styles)(LettersTable);
